














































import { Component, Prop, Vue } from 'vue-property-decorator'
import Device from './Device.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderDeviceChatPreviewHeader from '@/components/builder/BuilderDeviceChatPreviewHeader.vue'
import BuilderDevicePreviewFooter from '@/components/builder/BuilderDevicePreviewFooter.vue'
@Component({
  components: {
    BuilderDevicePreviewFooter,
    BuilderDeviceChatPreviewHeader,
    BuilderDevice,
    Device,
  },
})
export default class AppExampleDialogMessages extends Vue {
  @Prop({ required: true, type: String }) color!: string
  @Prop({ required: false, type: String }) name!: string
  @Prop({ required: false, type: Boolean }) highlight!: boolean
}
